module.exports = __webpack_public_path__ + "img/map.427af44b.svg";